import {localStorageKey} from "@/api/config";
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Api from "@/api";
import StoragePlugin from 'vue-web-storage';
import VueDayjs from 'vue3-dayjs-plugin'
import PageHeader from "@/components/PageHeader.vue";
import SideMenu from "@/components/SideMenu.vue";
import 'dayjs/locale/ko';
import {vfmPlugin} from "vue-final-modal";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import ko from "element-plus/dist/locale/ko"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import SimpleVueValidator from 'simple-vue3-validator'
import VueDaumPostcode from 'vue-daum-postcode'
import moment from 'moment';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import $ from "jquery";

window.$ = $
window.global = window;

let app = createApp(App);
app.use(router)
app.use(vfmPlugin)
app.use(VueDaumPostcode)
app.use(StoragePlugin, {
    prefix: localStorageKey,
    drivers: ['local'],
})
app.use(VueDayjs)
app.component('QuillEditor', QuillEditor)
app.component('page-header', PageHeader)
app.component('side-menu', SideMenu)

app.config.globalProperties.$api = Api;

app.use(ElementPlus, {
    locale: ko
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.config.globalProperties.$moment = moment;
app.use(SimpleVueValidator);
app.use(store)
app.mount('#app')
